import React, { FC } from "react";

export interface UploadProgressOverlayProps {
  percent?: number;
  muted?: boolean;
  message?: string;
  showBar?: boolean;
  className?: string;
}

const overlayBase =
  "absolute inset-0 z-[5] flex items-center justify-center rounded-[5px] bg-black/70";

const overlayMuted = "bg-[rgba(80,80,80,0.72)]";

const contentClass = "w-[90%] max-w-[200px] px-1 text-center text-white";

const textBase = "mb-2 line-clamp-3 break-all text-sm font-semibold text-white";

const textMuted = "mb-0 text-[11px] font-semibold tracking-wide text-white";

const barTrackClass = "h-1 w-full overflow-hidden rounded-sm bg-white/30";

const barFillClass =
  "h-full rounded-sm bg-[linear-gradient(90deg,#1890ff_0%,#40a9ff_100%)] transition-[width] duration-300 ease-in-out";

export const UploadProgressOverlay: FC<UploadProgressOverlayProps> = ({
  percent = 0,
  muted = false,
  message,
  showBar = true,
  className = "",
}) => {
  const safe = Number.isFinite(percent) ? Math.max(0, Math.min(100, Math.round(percent))) : 0;
  const text = message ?? `${safe}%`;

  return (
    <div className={`${overlayBase} ${muted ? overlayMuted : ""} ${className}`.trim()}>
      <div className={contentClass}>
        <div className={`${textBase} ${muted ? textMuted : ""}`.trim()}>{text}</div>
        {showBar ? (
          <div className={barTrackClass} aria-hidden>
            <div className={barFillClass} style={{ width: `${safe}%` }} />
          </div>
        ) : null}
      </div>
    </div>
  );
};
